
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Ursachen von Cluster-Kopfschmerzen liegen im Dunkeln. Eine genetische
Veranlagung kann eine Rolle spielen oder auch Rauchen. Vermutlich liegt das
Problem aber primär im Hypothalamus. Dieser wichtige Bereich im Zwischenhirn
steuert viele Vorgänge im Körper: Temperatur, Hunger, Blutdruck, Schlafrhythmus,
Sexualität und anderes mehr. Zu dieser These passt, dass Cluster-Kopfschmerzen
sich zu gewissen Zeiten häufen. Möglicherweise kommt es zu einer Aktivierung des
Hypothalamus und als Folge dessen zu einer Reizung eines Trigeminusnervs sowie
des autonomen (parasympathischen) Nervensystems. Eine andere Theorie macht
Entzündungsvorgänge im Bereich bestimmter Venen im Kopf verantwortlich.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;